import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { markNewsSeen, newsUnseen, type NewsTo } from "../news";
import { lazyView, ViewShell } from "../views";
import { ShellIcon } from "./ShellIcons";

// What the versions brought, their pictures and their styles are a download of their
// own, asked for when the drawer opens — like the pages in views.tsx, so the console's
// first opening never waits for a log nobody has opened. The frame slides in at once.
const loadLog = () => import("./NewsLog");
const NewsLog = lazyView(loadLog);

/** While the log's file comes: the shape of the newest version, so nothing jumps when it arrives. */
function LogWait() {
  return (
    <div className="news-wait" aria-label="在载入">
      <i />
      <i />
      <i />
    </div>
  );
}

/**
 * 更新了什么, from the sidebar's foot or the phone's 更多: the newest version
 * open with its few best things in pictures, the older ones folded; 去看看
 * opens that page. Opening it is reading it — the 「新」 beside the menu row
 * goes, and inside, the versions not opened before are marked this once.
 */
export default function NewsDrawer({ onClose, onGo }: { onClose: () => void; onGo: (to: NewsTo) => void }) {
  const [unseen] = useState(newsUnseen);
  useEffect(() => markNewsSeen(), []);
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [onClose]);

  return createPortal(
    <>
      <div className="news-scrim" onClick={onClose} />
      <aside className="news-drawer" role="dialog" aria-modal="true" aria-label="更新了什么">
        <div className="news-h">
          <span className="news-hi">
            <ShellIcon name="sparkles" size={18} />
          </span>
          <div className="news-ht">
            <b>更新了什么</b>
            <small>每一版改了什么，按「去看看」过去</small>
          </div>
          <button type="button" className="news-x" onClick={onClose} aria-label="关掉">
            <ShellIcon name="x" />
          </button>
        </div>
        <div className="news-b">
          <ViewShell wait={<LogWait />}>
            <NewsLog
              unseen={unseen}
              go={(to) => {
                onClose();
                onGo(to);
              }}
            />
          </ViewShell>
        </div>
      </aside>
    </>,
    document.body,
  );
}
